import { render } from "./VacancyCard.vue?vue&type=template&id=077a424a&scoped=true"
import script from "./VacancyCard.vue?vue&type=script&lang=js"
export * from "./VacancyCard.vue?vue&type=script&lang=js"

import "../pages/public-job-vacancy.scss?vue&type=style&index=0&id=077a424a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077a424a"]])

export default __exports__